import { render } from "./Icon.vue?vue&type=template&id=75bd2355"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Shared/Icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75bd2355"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75bd2355', __exports__)) {
    console.log('reload')
    api.reload('75bd2355', __exports__)
  }
  
  module.hot.accept("./Icon.vue?vue&type=template&id=75bd2355", () => {
    console.log('re-render')
    api.rerender('75bd2355', render)
  })

}


export default __exports__